import '../style/IndexingIndicator.css';

const IndexingIndicator = ({ embeddingProgress }) => {
    if (!embeddingProgress) return null;

    // Parse progress like "Indexing 3/10" to get percentage
    const match = embeddingProgress.match(/(\d+)\/(\d+)/);
    const current = match ? parseInt(match[1]) : null;
    const total = match ? parseInt(match[2]) : null;
    const percentage = current && total ? (current / total) * 100 : null;
    const isIndeterminate = percentage === null;

    return (
        <div className="indexing-indicator">
            <div className="indexing-dot" />
            <span className="indexing-text">{embeddingProgress}</span>
            <div className="indexing-progress-track">
                <div
                    className={`indexing-progress-bar${isIndeterminate ? ' indeterminate' : ''}`}
                    style={percentage !== null ? { width: `${percentage}%` } : undefined}
                />
            </div>
        </div>
    );
};

export default IndexingIndicator;
